/**
 * LAS PÁGINAS DEL SITIO, PARA QUE EL BUSCADOR TAMBIÉN LAS ENCUENTRE.
 *
 * 🔴 EL AGUJERO QUE CIERRA (Faina, 28-ago): «y si escribe misión, ¿se va a la
 * misión en las canalizaciones o a la misión de la Fundación?».
 *
 * Iba SIEMPRE a las canalizaciones, porque el buscador solo indexaba las 94
 * piezas. Quien escribía «misión» recibía cinco canalizaciones que la mencionan
 * de paso —ninguna con la palabra en el título— y la misión de la Fundación,
 * que está escrita en /nosotros, no aparecía por ningún lado.
 *
 * Y «misión» es justo la palabra que lo destapa, porque aquí son DOS COSAS
 * distintas y las dos existen en el sitio: la misión de la Fundación —lo que
 * hacemos— y la misión del alma —lo que cuesta, el aprendizaje que se viene a
 * hacer a esta encarnación—. Un buscador que solo conoce una de las dos
 * responde mal a la mitad de la gente.
 *
 * Lo mismo pasaba con canalización, trabajador de la luz, enseñanza, donar o
 * contacto: todas viven en páginas y el buscador no las veía.
 *
 * QUÉ VA EN `busca`: las palabras por las que alguien buscaría ESA página. No
 * es el texto de la página —eso traería ruido y competiría con el catálogo—,
 * sino sus términos propios. La lista se mantiene a mano, a propósito: son
 * ocho páginas, y una mala palabra aquí manda a alguien al sitio equivocado.
 */

import { ofreceConservacion } from './sites';

/* `titulo` y `frase` son CLAVES de texto (13-sep, /traducir-web): se pintan
   con t(). `busca` son las palabras por las que se encuentra la página y se
   quedan en español a propósito: el buscador busca en español. */
export const PAGINAS = [
  {
    ruta: '/nosotros',
    titulo: 'busca.fundacion_titulo',
    frase: 'busca.fundacion_frase',
    busca: 'fundacion mision proposito quienes somos nosotros valores reglas '
         + 'como trabajamos jeshua ben joseph chile constitucion rut registro '
         + 'donar donacion apoyar colaborar transparencia'
  },
  {
    ruta: '/trabajadores-de-la-luz',
    titulo: 'busca.tdl_titulo',
    frase: 'busca.tdl_frase',
    busca: 'trabajadores de la luz trabajador lightworker distinto diferente '
         + 'sensible no encajo no pertenezco despertar mision de vida'
  },
  {
    ruta: '/voces',
    titulo: 'busca.voces_titulo',
    frase: 'busca.voces_frase',
    busca: 'voces entidades quien habla angeles arcangeles esenios jeshua maria '
         + 'magdalena ana miguel gabriel rafael uriel chamuel jofiel zadquiel '
         + 'metatron rayos colores'
  },
  {
    ruta: '/canalizaciones',
    titulo: 'busca.biblioteca_titulo',
    frase: 'busca.biblioteca_frase',
    busca: 'biblioteca canalizaciones catalogo leer todas indice listado '
         + 'enseñanzas temas'
  },
  {
    ruta: '/33',
    titulo: 'busca.t33_titulo',
    frase: 'busca.t33_frase',
    busca: '33 treinta y tres numero enseñanzas 33 enseñanzas numero maestro '
         + 'jeshua 33 años mineros chile vertebras david lag baomer dante'
  },
  {
    ruta: '/gracias',
    titulo: 'busca.gracias_titulo',
    frase: 'busca.gracias_frase',
    busca: 'gracias agradecimientos canalizadores cantantes musicos autores '
         + 'creditos fuentes quienes escucharon'
  },
  {
    ruta: '/contacto',
    titulo: 'busca.contacto_titulo',
    frase: 'busca.contacto_frase',
    busca: 'contacto escribir correo email telefono whatsapp direccion hablar '
         + 'preguntar dudas ayuda'
  },
  {
    /* Def 74. Solo existe en .cl y .es, asi que el buscador tampoco puede
       ofrecerla en el sitio internacional: mandaria a una direccion que alli no
       responde. Lo filtra `paginasQueResponden`. */
    ruta: '/conservacion',
    soloSiConserva: true,
    titulo: 'busca.conservacion_titulo',
    frase: 'busca.conservacion_frase',
    busca: 'conservacion conservar tierra terreno predio finca hectareas campo '
         + 'bosque naturaleza medio ambiente madre tierra gaia donar donacion '
         + 'donante legado herencia custodia del territorio derecho real de '
         + 'conservacion proteger preservar independencia'
  },
  {
    ruta: '/entrar',
    titulo: 'busca.entrar_titulo',
    frase: 'busca.entrar_frase',
    busca: 'entrar registro registrarse cuenta donacion donar donaciones colaborador aporte '
         + 'gratis personalizado mi nombre acceder iniciar sesion'
  }
];

const sinAcentos = (t) => String(t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const INDICE_PAGINAS = PAGINAS.map((p) => ({
  ...p,
  /* Solo `busca`: el titulo y la frase son claves de texto desde el 13-sep, y
     sus palabras en español ya estan en `busca`. */
  buscable: sinAcentos(p.busca)
}));

/** Las páginas que responden a TODAS las palabras escritas. */
export const paginasQueResponden = (palabras) => {
  if (!palabras || !palabras.length) return [];
  /* Una pagina que este sitio no sirve no puede aparecer en sus resultados. */
  const disponibles = INDICE_PAGINAS.filter(
    (p) => !p.soloSiConserva || ofreceConservacion());
  return disponibles.filter((p) => palabras.every((w) => p.buscable.includes(w)));
};
